import { render } from "./cryptoBalances.vue?vue&type=template&id=4c59295d&ts=true"
import script from "./cryptoBalances.vue?vue&type=script&lang=ts"
export * from "./cryptoBalances.vue?vue&type=script&lang=ts"

import "./cryptoBalances.vue?vue&type=style&index=0&id=4c59295d&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__